import { IDocumentModel } from "./../../interfaces/document-model";
import { GenericTabModel } from "./../../models/tabs/generic-tab";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

export class GenericTabView extends Marionette.LayoutView<GenericTabModel> {

    public model: GenericTabModel;
    protected contentRegion: Marionette.Region;
    private contentView: Marionette.ItemView<IDocumentModel>;
    private template: string;

    public constructor(options?) {
        super(options);
        if (this.model.Template) {
            this.template = this.model.Template;
        }
        // This is here specifically instead of in a setupModelListeners() method to prevent errors if people override it and don't call super.setupModelListeners()
        this.listenTo(this.model, "change:Active", this.activeChanged);
    }

    public activeChanged(model, prop) {
        this.$(".document-section").removeClass("active");
        if (this.model.Active) {
            this.$(".document-section").addClass("active");
        }
    }

    public regions(): any {
        return {
            contentRegion: ".generic-content-region"
        };
    }

    public onShow() {
        if (this.model.ItemViewType) {
            const options: any = {model : this.model.Data};
            if (this.model.ChildTemplate) { // Sometimes template is specified by tab definition, sometimes its supplied in the view
                options.template = this.model.ChildTemplate;
            }
            this.contentView = new this.model.ItemViewType(options);
        } else {
            this.contentView = new Marionette.ItemView<IDocumentModel>();
        }
        this.contentRegion.show(this.contentView);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/generic-tab.ts